/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
const versionInfo = (() => {
  try {
    // @ts-ignore
    return require('../../git-version.json')
  } catch {
    // In dev the file might not exist:
    return { hash: 'prod' }
  }
})()

// @ts-ignore
const pkg = require('../../package.json')

export const environment = {
  production: true,
  API_ROOT: 'https://maimemostatus.com/api/v1',
  FEISHU_PROXY_API_ROOT: 'https://gitlab-automations.maimemo.com/api/v1',
  version: `v${pkg.version} ${versionInfo.hash.substr(0, 7)}`,
  tagV2RootId: '5ec799de59b61347981aa6ce',
  tagV2RemarkRewardId: '5ed9bbf83694db3c2dfe2f7b'
}
